<template>
  <v-card elevation="3" color="#FFFFFF">
    <v-card-title class="question" style="word-break: normal"
      >{{ question.literalNumber }} {{ question.question }}</v-card-title
    >
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th
              class="header"
              :class="{ 'disabled-text-header': disabledAnswers }"
              v-for="(title, t) in question.options.split(';')"
              :key="t"
            >
              <p class="disabled-text-header">{{ cleanTittle(title) }}</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rowsCount"
            :key="'row' + row"
            style="word-break: normal"
          >
            <td v-for="ans in question.options.split(';').length" :key="ans">
              <v-textarea
                :disabled="disabledAnswers"
                class="answer"
                auto-grow
                rows="1"
                :class="{ 'disabled-text': disabledAnswers }"
                v-if="
                  !question.options
                    .split(';')
                    [ans - 1].includes('seleccione') && !isNumeric(ans)
                "
                v-model="currentAns[row - 1][ans - 1]"
                v-on:keyup="registerAnswer(questionNumber)"
                label
              ></v-textarea>
              <v-textarea
                :disabled="disabledAnswers"
                class="answer"
                auto-grow
                rows="1"
                :class="{ 'disabled-text': disabledAnswers }"
                v-if="
                  !question.options
                    .split(';')
                    [ans - 1].includes('seleccione') && isNumeric(ans)
                "
                v-model="currentAns[row - 1][ans - 1]"
                v-on:keyup="registerAnswer(questionNumber)"
                label
                type="number"
              ></v-textarea>
              <v-autocomplete
                :disabled="disabledAnswers"
                class="answer"
                :class="{ 'disabled-text': disabledAnswers }"
                :items="getDropOptions(question.options.split(';')[ans - 1])"
                v-model="currentAns[row - 1][ans - 1]"
                @change="registerAnswer(questionNumber)"
                v-if="
                  question.options.split(';')[ans - 1].includes('seleccione')
                "
              ></v-autocomplete>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      currentAns: [[""]],
      answerVal: [],
      rowsCount: 1,
      ans: "",
      savedAns: "",
      bracketsRegex: /(\(([^)]+)\))/g,
    };
  },
  props: {
    question: Object,
    questionNumber: String,
    answer: String,
    disabledAnswers: Boolean,
  },
  methods: {
    displayOther(value) {
      this.show = value;
    },
    registerAnswer(number) {
      // generate extra row for answers
      let columns = this.question.options.split(";");
      let ans = "";
      if (!this.isEmptyRow(this.currentAns[this.rowsCount - 1])) {
        this.rowsCount++;
        this.currentAns.push(new Array(columns.length - 1).fill(null));
      }

      let rows = 1;

      if (this.currentAns.length > 1) {
        rows = this.currentAns.length;
      }
      for (let cRow = 0; cRow < rows; cRow++) {
        for (let index = 0; index < columns.length; index++) {
          let value = this.currentAns[cRow][index];
          if (value == undefined) {
            value = "";
          }

          ans += value + ";";
        }
      }

      this.savedAns = ans;
      this.savedAns = this.savedAns.substring(0, this.savedAns.length - 1);

      this.$emit("selectTableAnswer", {
        number: number,
        answer: this.savedAns,
      });
    },
    getDropOptions(text) {
      let found = text.match(this.bracketsRegex);
      if ((found != null && found.length) != 0) {
        found[0] = found[0].substring(1, found[0].length - 1);

        let arr = found[0].split(":").sort();
        return arr;
      }
      return [];
    },
    cleanTittle(text) {
      let found = text.match(this.bracketsRegex);
      if ((found != null && found.length) != 0) {
        text = text.replace(found[0] + " seleccione", "");
      }

      return text;
    },
    isEmptyRow(row) {
      let empty = true;
      row.forEach((element) => {
        if (element != null) {
          empty = false;
        }
      });

      return empty;
    },
    isNumeric(headerNum) {
      let header = this.question.options.split(";");
      if (header[headerNum - 1].toUpperCase().includes("AÑO")) {
        return true;
      }
      return false;
    },
    isEditing() {
      return this.answer == undefined;
    },
  },
  mounted() {
    if (this.answer != null) {
      let rawAnswers = this.answer.split(";");
      let counts = this.question.options.split(";");
      let ans = [];
      this.currentAns = [];
      for (let index = 0; index < rawAnswers.length; index++) {
        ans.push(rawAnswers[index]);
        if ((index + 1) % counts.length == 0) {
          let currentRow = [];
          ans.forEach((answer) => {
            currentRow.push(answer);
          });
          this.currentAns.push(currentRow);
          this.rowsCount++;
          ans = [];
        }
      }
      if (this.rowsCount != 1) {
        this.rowsCount--;
      }
    }

    if (this.currentAns.length == 0) {
      let columns = this.question.options.split(";");
      this.currentAns.push(new Array(columns.length - 1).fill(null));
    }
  },
};
</script>
<style scoped>
@media print {
  .v-list-item__content {
    page-break-inside: avoid;
  }
}
.text {
  word-break: normal;
}

.header {
  word-break: normal;
  font-weight: 700;
  font-size: 0.4cm;
  color: black;
  -webkit-text-fill-color: black;
}
.question {
  font-size: 21px;
  overflow-wrap: break-word;
  word-break: break-word;
  font-weight: 600;
}

.disabled-text {
  font-weight: 100;
  color: black;
  -webkit-text-fill-color: black;
}

.disabled-text-header {
  font-weight: 550;
  font-size: 18px;
  color: black;
  -webkit-text-fill-color: black;
}
</style>